export default __webpack_public_path__ + "static/media/icono-3.c659cf26.jpg";